import { Link, useLocation } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { ListItemText } from "@mui/material";
import { ThemeMode } from "config";
import { LinkTarget } from "types/menu";

interface NavItemType {
  title: string;
  url: string;
  icon?: React.ReactNode;
  isMd: boolean;
}

interface Props {
  item: NavItemType;
}

export default function NavItem({ item }: Props) {
  const theme = useTheme();
  const { pathname } = useLocation();
  // const textColor =
  //   theme.palette.mode === ThemeMode.DARK ? "grey.400" : "text.primary";
  // const iconSelectedColor =
  //   theme.palette.mode === ThemeMode.DARK ? "text.primary" : "black";
  const itemTarget: LinkTarget = "_self";

  const isSelectedItem = item.url === pathname;
  return (
    <ListItemButton
      component={Link}
      to={item.url!}
      target={itemTarget}
      sx={{
        cursor: "pointer",
        pl: 2,
        padding: 2,
        marginLeft: item.isMd ? 2 : 0,
        py: "0.5rem",
        mb: 0.5,
        "&:hover": {
          bgcolor: {
            xs:
              theme.palette.mode === ThemeMode.DARK
                ? "divider"
                : "primary.lighter",
            sm:
              theme.palette.mode === ThemeMode.DARK
                ? "divider"
                : "primary.lighter",
            md:
              theme.palette.mode === ThemeMode.DARK
                ? "transparent"
                : "transparent",
          },
        },
        "&.Mui-selected": {
          bgcolor:
            theme.palette.mode === ThemeMode.DARK
              ? "divider"
              : "primary.lighter",
          borderColor: "primary.main",
          "&:hover": {
            bgcolor: {
              xs:
                theme.palette.mode === ThemeMode.DARK
                  ? "divider"
                  : "primary.lighter",
              sm:
                theme.palette.mode === ThemeMode.DARK
                  ? "divider"
                  : "primary.lighter",
              md:
                theme.palette.mode === ThemeMode.DARK
                  ? "transparent"
                  : "transparent",
            },
          },
        },
        borderBottom: {
          xs: `1px solid ${theme.palette.divider}`,
          sm: `1px solid ${theme.palette.divider}`,
          md: "none",
        },
        width: { xs: "100%", sm: "100%", md: "auto" },
        bgcolor: {
          xs: isSelectedItem ? "#009687" : "transparent",
          sm: isSelectedItem ? "#009687" : "transparent",
          md: isSelectedItem ? "transparent" : "transparent",
        },
        borderRadius: { xs: 0, sm: 0, md: 0 },
      }}
    >
      <ListItemText
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        primary={
          <Typography
            whiteSpace={"nowrap"}
            variant="h5"
            sx={{
              color: {
                xs: isSelectedItem ? "white" : "black",
                sm: isSelectedItem ? "white" : "black",
                md: isSelectedItem ? "#009687" : "white",
              },
            }}
          >
            {item.icon}
            <span style={{ marginLeft: 6, fontWeight: 600 }}>{item.title}</span>
          </Typography>
        }
      />
    </ListItemButton>
  );
}
